var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.568 4.248a.5.5 0 0 1 .864.504 8.6 8.6 0 0 1-2.366 2.607l2.116 2.116a.5.5 0 1 1-.707.707L12.354 8.06a.5.5 0 0 1-.113-.173 8.6 8.6 0 0 1-1.971.81l1.346 2.333a.5.5 0 0 1-.866.5l-1.5-2.598-.01-.023a8.7 8.7 0 0 1-1.657.078l-1.467 2.543a.5.5 0 0 1-.866-.5L6.497 8.87a8.6 8.6 0 0 1-2.351-.773L2.06 10.182a.5.5 0 1 1-.707-.707l1.895-1.897a8.6 8.6 0 0 1-2.68-2.826.5.5 0 0 1 .863-.504A7.59 7.59 0 0 0 8 8a7.59 7.59 0 0 0 6.568-3.752"
})));
export default SvgEyeClose;